module.exports = __webpack_public_path__ + "static/img/OregonInshore-RA.9c25180.png";